import React from 'react';

function DonationItem({ name, about, url, image }) {
  const IMG_PATH = `${process.env.PUBLIC_URL}/images/${image}`;
  return (
    <div className="org">
      <div className="org-header">
        <div className="org-thumbnail">
          <img src={`${IMG_PATH}`} alt={`${name} picture`} />
        </div>
        <a className="donate-button" href={url}>
          Donate
        </a>
      </div>
    </div>
  );
}

export default DonationItem;
